import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { ToolbarModule } from '@hiptraveler/features/site-navigation';
import { ButtonsModule } from '@hiptraveler/ui/buttons';
import { UploadProfilePhotoDirectiveModule } from './../common';

import { BannerComponent } from './banner.component';
import { UploadCoverPhotoDirective } from './upload-cover-photo.directive';
import { NavbarAppendHighlightDirective } from './navbar-append-highlight.directive';
import { SelectionPipe } from './selection.pipe';

const MODULES = [
  CommonModule,
  MatIconModule,
  MatProgressSpinnerModule,
  TranslateModule,
  LazyLoadImageModule
];

const LIBRARIES = [
  ToolbarModule,
  ButtonsModule,
  UploadProfilePhotoDirectiveModule
];

const COMPONENTS = [
  BannerComponent
];

const DIRECTIVES = [
  UploadCoverPhotoDirective,
  NavbarAppendHighlightDirective
];

const PIPES = [
  SelectionPipe
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS,
    DIRECTIVES,
    PIPES
  ],
  exports: [
    BannerComponent
  ]
})
export class BannerModule { }
